import {apiGetAccountingSalaries} from "api/accountingTypeApi";

import {PriceComponent} from "components/Table/CellComponents";
import SalaryDocumentSetting from "components/Table/SalaryDocumentSetting";

const salaryDocumentColumns = [
    {
        name: "تاریخ",
        key: "date",
        size: "2",
        searchType: "date",
    },
    {
        name: "کد حسابداری",
        key: "accountingCode",
        size: "2",
    },
    {
        name: "شرح",
        key: "description",
        size: "7",
    },
    {
        name: "بدهکار",
        key: "creditor",
        price: true,
        // @ts-ignore
        getValue: (item) => {
            return !item.isCreditor ? item.amount.toString() : "-";
        },
        Component: PriceComponent,
        size: "3",
        searchType: "quantitative",
    },
    {
        name: "بستانکار",
        key: "receptor",
        price: true,
        // @ts-ignore
        getValue: (item) => {
            return item.isCreditor ? item.amount.toString() : "-";
        },
        Component: PriceComponent,
        size: "3",
        searchType: "quantitative",
    },
    {
        name: "تراز",
        // @ts-ignore
        getValue: (item: any, all: any[]) => {
            let key = 0;
            let balance = 0;
            const index = all?.findIndex((object) => object.id === item.id);
            while (key <= index) {
                const currentItem = all[key];
                balance += currentItem.isCreditor ? currentItem.amount : 0;
                balance -= !currentItem.isCreditor ? currentItem.amount : 0;
                key += 1;
            }
            return Math.abs(balance);
        },
        key: "balance",
        Component: PriceComponent,
        size: "3",
        disableSearch: true,
    },
    {
        name: "تشخیص",
        // @ts-ignore
        getValue: (item: any, all: any[]) => {
            let key = 0;
            let balance = 0;
            const index = all?.findIndex((object) => object.description === item.description);
            while (key <= index) {
                const currentItem = all[key];
                balance += currentItem.isCreditor ? currentItem.amount : 0;
                balance -= !currentItem.isCreditor ? currentItem.amount : 0;
                key += 1;
            }
            return balance > 0 ? "بس" : balance < 0 ? "بد" : "-";
        },
        key: "diagnosis",
        size: "3",
        disableSearch: true,
    },
];

export const SalaryDocumentIndexData = [
    {
        key: "salaryDocument",
        label: "سند حقوق",
        pluralLabel: "سند حقوق",
        title: "سند حقوق",
        disableSearch: true,
        pageTitle: "سند حقوق",
        // pageDescription: "نمایش کالا و خدمات کسب و کار",
        tableColumns: salaryDocumentColumns,
        actions: {
            back: {},
            fetch: apiGetAccountingSalaries,
            // excel: {},
        },
        SettingComponent: SalaryDocumentSetting,
    },
];
